/*
 * tutor/stream — SSE reader for the tutor's OBJECT-frame dialect.
 *
 * Unlike the legacy /chat stream (bare JSON strings), every tutor frame is a
 * JSON object: {type: "hello"|"text_delta"|"render"|"update"|"ack"|"error"|"done", ...}.
 * Auth is attached globally by lib/authFetch. Resolves when a done/terminal
 * error frame arrives (or the stream closes).
 */
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export async function openTutorStream(path, body, { signal, onFrame } = {}) {
  const resp = await fetch(`${API_BASE_URL}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    signal,
  });
  if (!resp.ok || !resp.body) throw new Error(`Tutor stream failed: ${resp.status}`);
  const reader = resp.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split('\n');
    buffer = lines.pop();
    for (const line of lines) {
      if (!line.startsWith('data:')) continue;
      const payload = line.slice(5).trim();
      if (!payload) continue;
      let frame;
      try { frame = JSON.parse(payload); } catch { continue; }
      onFrame?.(frame);
      if (frame.type === 'done') return frame;
    }
  }
  return { type: 'done' };
}
